import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/AppLayout';
import { RequireAdmin } from '@/components/RequireAdmin';
import { NotFoundPage } from '@/components/NotFoundPage';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { LoginPage } from '@/pages/Login/LoginPage';
import { LanguagesListPage } from '@/pages/Languages/LanguagesListPage';
import { TranslationEditorPage } from '@/pages/TranslationEditor/TranslationEditorPage';
import { GlossaryListPage } from '@/pages/Glossary/GlossaryListPage';
import { InvestorsListPage } from '@/pages/Investors/InvestorsListPage';
import { UsersListPage } from '@/pages/Users/UsersListPage';
import { TopicsListPage } from '@/pages/Topics/TopicsListPage';
import { TopicEditPage } from '@/pages/Topics/TopicEditPage';
import { HomeSectionsPage } from '@/pages/Home/HomeSectionsPage';
import { ContentCenterPage } from '@/pages/Content/ContentCenterPage';
import { SectionDetailPage } from '@/pages/Content/SectionDetailPage';
import { AiSettingsPage } from '@/pages/Settings/AiSettingsPage';
import { AiStudioPage } from './pages/Studio/AiStudioPage';
import { FlyersPage } from './pages/Flyers/FlyersPage';
import { TemplateEditorPage } from './pages/Flyers/TemplateEditorPage';
import { ComposeListPage } from './pages/Flyers/compose/ComposeListPage';
import { ComposerPage } from './pages/Flyers/compose/ComposerPage';
import { SystemSettingsPage } from './pages/System/SystemSettingsPage';

export function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAdmin>
              <AppLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<Navigate to="/topics" replace />} />
          <Route path="home" element={<HomeSectionsPage />} />
          <Route path="content" element={<ContentCenterPage />} />
          <Route path="content/:sectionId" element={<SectionDetailPage />} />
          <Route path="topics" element={<TopicsListPage />} />
          <Route path="topics/new" element={<TopicEditPage />} />
          <Route path="topics/:id" element={<TopicEditPage />} />
          <Route path="languages/*" element={<LanguagesListPage />} />
          <Route path="translations/*" element={<TranslationEditorPage />} />
          <Route path="glossary/*" element={<GlossaryListPage />} />
          <Route path="investors/*" element={<InvestorsListPage />} />
          <Route path="users/*" element={<UsersListPage />} />
          <Route path="ai-settings" element={<AiSettingsPage />} />
          <Route path="ai-studio" element={<AiStudioPage />} />
          <Route path="flyers" element={<FlyersPage />} />
          <Route path="flyers/templates/:id" element={<TemplateEditorPage />} />
          <Route path="flyers/compose" element={<ComposeListPage />} />
          <Route path="flyers/compose/:id" element={<ComposerPage />} />
          <Route path="system-settings" element={<SystemSettingsPage />} />
          <Route path="ai-providers" element={<Navigate to="/ai-settings" replace />} />
          <Route path="ai-models" element={<Navigate to="/ai-settings" replace />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}
